import Checkbox from "../../Category/Filter/Common/Checkbox";
import Button from "../../Shared/Button/Button";

const FilterRow = () => {
  return (
    <div className="grid w-full grid-cols-[290px_200px_auto_120px_200px] py-5">
      <p className="flex items-center">
        <Checkbox
          label={"Property to Rent and Subcategories"}
          labelClassName="!text-sm !text-black text-opacity-50"
        />
      </p>
      <p className="flex items-center font-pop text-sm text-black text-opacity-50">
        4 bedrooms
      </p>
      <p className="flex items-center font-pop text-sm text-black text-opacity-50">
        Johannesburg
      </p>
      <p className="flex items-center font-pop text-sm text-black text-opacity-50">
        Apr 16-8:52
      </p>
      <div className="flex items-center justify-end gap-2">
        <Button
          className="!w-auto !py-[5px] px-[24px] text-[8px]"
          text={"View"}
          variant="secondary"
        />
        <Button
          className="!w-auto !py-[5px] px-[24px] text-[8px]"
          text={"Delete Filter"}
          variant="red"
        />
      </div>
    </div>
  );
};

export default FilterRow;
